import React from 'react';
import ListTable from './components/ListTable';
import { Accordion, AccordionDetails, withStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';

const AccordionSummary = withStyles({
  root: {
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    }
  },
  content: {
    '&$expanded': {
      margin: '0 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

export const ListView = ({
  data,
  slaColumnInfo,
  customFields,
  handleUpdate,
  handleCall,
  disableClickToCall,
  protocolDefaultFieldsDisplaySettings,
  status,
  stagePageInfo,
  onTableGrow
}) => {
  const render = () => {
    const keys = Object.keys(data);

    return (
      <div>
        {keys.map((key) => {
          const _status = status.find((item) => item.id === key);
          const color = _status?.color ?? '';
          const stage = stagePageInfo.find((data_) => {
            return data_.id === key;
          });
          return (
            <>
              <Accordion
                defaultExpanded
                style={{ padding: '5px', boxShadow: 'none' }}
                key={key}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{
                    background: 'rgb(233,236,239)',
                    borderLeft: `3px solid ${color ?? 'rgb(233, 236, 239)'}`,
                    borderRadius: '10px'
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <strong> {_status?.name ?? ''}</strong>
                    <div
                      style={{
                        minWidth: '20px',
                        maxWidth: '100%',
                        border: `1px solid lightgray`,
                        borderRadius: '40%',
                        padding: '2px',
                        marginLeft: '5px',
                        textAlign: 'center'
                      }}
                    >
                      {stage?.count ?? 0}
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  {' '}
                  <ListTable
                    customFields={customFields}
                    data={data[key] ?? []}
                    handleUpdate={handleUpdate}
                    handleCall={handleCall}
                    disableClickToCall={disableClickToCall}
                    protocolDefaultFieldsDisplaySettings={
                      protocolDefaultFieldsDisplaySettings
                    }
                    stagePageInfo={stage}
                    stageId={key}
                    onTableGrow={onTableGrow}
                    slaColumnInfo={slaColumnInfo}
                  ></ListTable>
                </AccordionDetails>
              </Accordion>
            </>
          );
        })}
      </div>
    );
  };

  return render();
};
